import { useState } from 'react';
import axios from 'axios';
import { API_URL } from './utils';

export const AccountsTab = ({ authHeaders, onAccountCreated }) => {
  const [acctUsername, setAcctUsername] = useState('');
  const [acctPassword, setAcctPassword] = useState('');
  const [acctConfirmPassword, setAcctConfirmPassword] = useState('');
  const [acctRole, setAcctRole] = useState('user');
  const [acctLoading, setAcctLoading] = useState(false);
  const [acctError, setAcctError] = useState(null);
  const [acctSuccess, setAcctSuccess] = useState(null);

  const handleCreateAccount = async (e) => {
    e.preventDefault();
    setAcctError(null);
    setAcctSuccess(null);

    if (!acctUsername.trim() || acctUsername.trim().length < 3) {
      setAcctError('Username must be at least 3 characters');
      return;
    }
    if (acctPassword.length < 6) {
      setAcctError('Password must be at least 6 characters');
      return;
    }
    if (acctPassword !== acctConfirmPassword) {
      setAcctError('Passwords do not match');
      return;
    }

    setAcctLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/api/admin/accounts`,
        { username: acctUsername.trim(), password: acctPassword, role: acctRole },
        { headers: authHeaders() },
      );
      setAcctSuccess(`Account "${res.data.username}" created successfully.`);
      setAcctUsername('');
      setAcctPassword('');
      setAcctConfirmPassword('');
      setAcctRole('user');
      onAccountCreated?.();
    } catch (err) {
      setAcctError(err.response?.data?.error || err.message || 'Failed to create account');
    } finally {
      setAcctLoading(false);
    }
  };

  return (
    <div className="AdminPortal-accountsPane">
      <h2 className="AdminPortal-sectionTitle">Create Account</h2>
      <p className="AdminPortal-sectionLead">
        Provision a new user account. Share the credentials directly with the user.
      </p>

      {acctSuccess && (
        <div className="AdminPortal-banner AdminPortal-banner--success" role="status">
          {acctSuccess}
        </div>
      )}
      {acctError && (
        <div className="AdminPortal-banner AdminPortal-banner--error" role="alert">
          {acctError}
        </div>
      )}

      <form className="AdminPortal-accountsForm" onSubmit={handleCreateAccount}>
        <div className="AdminPortal-field">
          <label className="AdminPortal-fieldLabel" htmlFor="acct-username">Username</label>
          <input
            id="acct-username"
            className="AdminPortal-input"
            type="text"
            value={acctUsername}
            onChange={(e) => setAcctUsername(e.target.value)}
            placeholder="e.g. john_doe"
            disabled={acctLoading}
            autoComplete="off"
          />
        </div>

        <div className="AdminPortal-field">
          <label className="AdminPortal-fieldLabel" htmlFor="acct-password">Password</label>
          <input
            id="acct-password"
            className="AdminPortal-input"
            type="password"
            value={acctPassword}
            onChange={(e) => setAcctPassword(e.target.value)}
            placeholder="Min 6 characters"
            disabled={acctLoading}
            autoComplete="new-password"
          />
        </div>

        <div className="AdminPortal-field">
          <label className="AdminPortal-fieldLabel" htmlFor="acct-confirm">Confirm Password</label>
          <input
            id="acct-confirm"
            className="AdminPortal-input"
            type="password"
            value={acctConfirmPassword}
            onChange={(e) => setAcctConfirmPassword(e.target.value)}
            placeholder="Re-enter password"
            disabled={acctLoading}
            autoComplete="new-password"
          />
        </div>

        <div className="AdminPortal-field">
          <label className="AdminPortal-fieldLabel" htmlFor="acct-role">Role</label>
          <select
            id="acct-role"
            className="AdminPortal-select"
            value={acctRole}
            onChange={(e) => setAcctRole(e.target.value)}
            disabled={acctLoading}
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        <button
          type="submit"
          className="ChatButton AdminPortal-accountsSubmit"
          disabled={acctLoading}
        >
          {acctLoading ? 'Creating...' : 'Create Account'}
        </button>
      </form>
    </div>
  );
};
